// extracted by mini-css-extract-plugin
module.exports = {"toolsPage":"ToolsPage-module--toolsPage--3r-LR","toolsHeader":"ToolsPage-module--toolsHeader--6EzUK"};